/**
 * @example this should only be added once on <body> tag
 * @returns {boolean}
 */

export default (vue) => {

    const short = vue.get('shorts[' + vue.get(vue.exp) + ']');

    short.videoElement = vue.el;

    // First check for native browser HLS support
    if( vue.get('nativeHlsSupported') && short.video.hls) {
        short.videoElement.src = short.video.hls;

        // If no native HLS support, check if HLS.js is supported
    } else if( vue.get('hlsObject') && short.video.hls) {
        if(short.playing) {
            vue.get('hlsObject').loadSource(short.video.hls);
            vue.get('hlsObject').attachMedia(short.videoElement);
        }

        // Fallback to mp4
    } else {
        short.videoElement.src = short.video.mp4;
    }

    short.videoElement.addEventListener('loadedmetadata', function() {
        short.videoElement.dataset.loaded = 'true';
        short.videoElement.muted = short.muted;

        if(short.playing) {
            short.videoElement.play().then();
        }
    }, {passive: true});
};